import { allocatedSolarElectrical } from './solarElectricalTopology';
import { type SolarDesignDraftState } from './solarDesignDraft';

/** Current commercial prices, independent of the pinned technical profile. */
export const solarElectricalEquipmentQuantities = (
  state: SolarDesignDraftState
) => {
  const topology = allocatedSolarElectrical(state.electrical);
  if (!topology) return null;
  const selections = new Map(
    topology.equipmentSelections.map((item) => [item.id, item])
  );
  const quantities = new Map<string, number>();
  const add = (selectionId: string | undefined) => {
    const id = selections.get(selectionId ?? '')?.applianceId;
    if (!id) return false;
    quantities.set(id, (quantities.get(id) ?? 0) + 1);
    return true;
  };
  for (const panel of state.layout.workingPanels)
    if (
      panel.included &&
      !state.layout.excludedFaceIds.includes(panel.faceId) &&
      !add(panel.equipmentSelectionId)
    )
      return null;
  for (const instance of topology.inverterInstances)
    if (!add(instance.equipmentSelectionId)) return null;
  if (state.includeBattery) {
    const id = state.selectedBatteryApplianceId;
    const quantity = state.batteryQuantity ?? 1;
    if (!id || !Number.isInteger(quantity) || quantity < 1) return null;
    quantities.set(id, (quantities.get(id) ?? 0) + quantity);
  }
  return quantities;
};

export const solarElectricalEquipmentCost = (
  state: SolarDesignDraftState,
  prices: readonly {
    id: string;
    quantity?: number;
    items: readonly { id: string }[];
    totalPrice: { value: number; currency: { code: string; exponent: number } };
  }[]
) => {
  const quantities = solarElectricalEquipmentQuantities(state);
  if (!quantities) return null;
  let value = 0;
  let currency: { code: string; exponent: number } | undefined;
  for (const [id, quantity] of quantities) {
    const entry = prices.find((item) => item.id === id);
    if (!entry?.items?.length) return null;
    if (entry?.quantity !== undefined && entry.quantity !== quantity)
      return null;
    const price = entry?.totalPrice;
    if (!price || price.value < 0) return null;
    if (
      currency &&
      (currency.code !== price.currency.code ||
        currency.exponent !== price.currency.exponent)
    )
      return null;
    currency = price.currency;
    value += price.value * (entry?.quantity === undefined ? quantity : 1);
  }
  return currency ? { value, currency } : null;
};
